<app-page-header
    title="Categorías de Proceso"
    mobileTitle="Categorías"
    icon="fas fa-folder-open"
    optionsLabel="Opciones"
    optionsIcon="fa fa-cog"
    [hasOptions]="!showMobileDetail"
    [showBack]="showMobileDetail"
    [unifiedOnMobile]="showMobileDetail"
    (back)="closeDetail()">
    <div headerOptions>
        @if (perm.canCurrent('canCreate')) {
        <a class="dropdown-item" (click)="newCategoryModal()">
            <i class="fas fa-plus fa-fw me-2 text-primary"></i> Nueva categoría
        </a>
        }
    </div>
</app-page-header>

@if (!showMobileDetail) {
<div class="row">
    <div class="col-12" [class.col-md-12]="!appSettings.isMobile()"
         [class.mobile-requests-container]="appSettings.isMobile()">
        <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
            <app-process-category-list (selectEvent)="onCategorySelected($event)">
                @if (perm.canCurrent('canCreate')) {
                <button class="btn btn-primary btn-sm" (click)="newCategoryModal()">
                    <i class="fas fa-plus"></i> Nueva categoría
                </button>
                }
            </app-process-category-list>
        </div>
    </div>
</div>
} @else {
<div class="panel p-3 mb-3">
    <h5 class="mb-3">{{ mode() === formMode.CREATE ? 'Nueva categoría' : 'Editar categoría' }}</h5>
    <app-process-category-form [categoryForm]="categoryForm" [mode]="mode()"></app-process-category-form>
    @if (mode() === formMode.EDIT && selectedCategory?.isActive !== false) {
        <div class="mt-3">
            <button type="button" class="btn btn-outline-warning btn-sm w-100" (click)="deactivateSelected()">
                <i class="fas fa-ban me-1"></i> Desactivar
            </button>
        </div>
    }
</div>
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm"
        [disabled]="categoryForm.invalid"
        (click)="saveCategory()">
        Guardar
    </button>
</app-mobile-footer>
}

<ng-template #categoryModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">{{ mode() === formMode.CREATE ? 'Nueva' : 'Editar' }} categoría</h4>
    </div>
    <div class="modal-body">
        <app-process-category-form [categoryForm]="categoryForm" [mode]="mode()"></app-process-category-form>
    </div>
    <div class="modal-footer justify-content-between">
        <div>
            @if (mode() === formMode.EDIT && selectedCategory?.isActive !== false) {
                <button type="button" class="btn btn-outline-warning" (click)="deactivateSelected()">
                    <i class="fas fa-ban me-1"></i> Desactivar
                </button>
            }
        </div>
        <div class="d-flex gap-2">
            <button type="button" class="btn btn-secondary" (click)="close()">Cancelar</button>
            <button type="button" class="btn btn-primary" (click)="saveCategory()" [disabled]="categoryForm.invalid">
                Guardar
            </button>
        </div>
    </div>
</ng-template>
